import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { disbursementsApi } from '../../api/endpoints/disbursements';
import { DisbursementInitiationRequest } from '../../api/types/disbursement.types';

export const usePendingDisbursements = () => {
  return useQuery({
    queryKey: ['disbursements', 'pending'],
    queryFn: () => disbursementsApi.getPending(),
  });
};

export const useInitiateDisbursement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: DisbursementInitiationRequest) => disbursementsApi.initiate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['disbursements'] });
      queryClient.invalidateQueries({ queryKey: ['loans'] });
    },
  });
};
